export default "__VITE_ASSET__CxnfF2Qx__"